<template>
  <div class="container-fluid">
    <b-modal
      hide-footer
      hide-header
      id="delete_modal"
      color="warning"
      :show.sync="warning_modal"
    >
      {{ $trans.main.delete_warning }}
      <b-button variant="outline-secondary" block class="btn mt-3" @click="$bvModal.hide('delete_modal')">
        {{ $trans.main.button_cancel }}
      </b-button>
      <b-button
        variant="outline-danger"
        block class="btn mt-3"
        @click="deleteProtocol(deleted_protocol); $bvModal.hide('delete_modal')"
      >
        {{ $trans.main.button_delete }}
      </b-button>
    </b-modal>
    <b-modal
      hide-footer
      hide-header
      id="modal_protocol_isset"
      color="warning"
      :show.sync="protocol_isset"
    >
      {{ $trans.main.isset_protocol_local_version }}
      <b-button
        variant="outline-secondary"
        block class="btn mt-3"
        @click="editLocalProtocol(); $bvModal.hide('modal_protocol_isset')"
      >
        {{ $trans.main.open_local_version }}
      </b-button>
      <b-button
        variant="outline-danger"
        block class="btn mt-3"
        @click="deleteLocalProtocol(); $bvModal.hide('modal_protocol_isset')"
      >
        {{ $trans.main.delete_local_version }}
      </b-button>
    </b-modal>
    <div class="row">
      <div class="col">
        <table class="table ">
          <thead>
          <tr>
            <th scope="col">{{ $trans.protocol.date }}</th>
            <th scope="col">{{ $trans.protocol.object }}</th>
            <th scope="col">{{ $trans.protocol.street }}</th>
            <th scope="col">{{ $trans.protocol.tenant }}</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <thead>
          <tr>
            <th scope="col"><input
              type="date"
              class="form-control"
              v-model="filters.date"
            ></th>
            <th scope="col">
              <input
                v-model="filters.object "
                type="text"
                class="form-control"
                id="object"
              >
            </th>
            <th scope="col">
              <input
                v-model="filters.street "
                type="text"
                class="form-control"
                id="street"
              >
            </th>
            <th scope="col">
              <input
                v-model="filters.tenant "
                type="text"
                class="form-control"
                id="tenant"
              >
            </th>
            <th scope="col">
              <button class="btn btn-secondary" @click="getProtocols">{{ $trans.main.button_apply }}</button>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="protocol in protocols">
            <td @click="editProtocol(protocol)">{{ moment(new Date(protocol.date)).format('DD.MM.YYYY') }}</td>
            <td @click="editProtocol(protocol)">{{ protocol.object }}</td>
            <td @click="editProtocol(protocol)">{{ protocol.street }}</td>
            <td @click="editProtocol(protocol)">{{ protocol.tenant }}</td>
            <td>
              <button v-if="is_user_admin"
                      class="btn btn-danger"
                      @click="deleteProtocolWarning(protocol)"
              >
                {{ $trans.main.button_delete }}
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="clearfix btn-group col-md-2 offset-md-5">
      <button type="button" class="btn btn-sm btn-outline-secondary" v-if="page != 1" @click="page--"> <</button>
      <button type="button" class="btn btn-sm btn-outline-secondary" v-for="pageNumber in pages.slice(page-1, page+5)"
              @click="page = pageNumber"> {{ pageNumber }}
      </button>
      <button type="button" @click="page++" v-if="page < pages.length" class="btn btn-sm btn-outline-secondary"> >
      </button>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import moment from 'moment'
import {mapActions} from 'vuex'
import idb from '../../functions/idb'

export default {
  name: 'LocalProtocols',
  data () {
    return {
      protocols: [],
      page: 1,
      filters: {
        date: ''
      },
      is_user_admin: this.$store.getters.hasRole('admin'),
      pages: [],
      deleted_protocol: {},
      warning_modal: false,
      protocol_isset: false,
      local_protocol: {},
      api_protocol_id: '',
      moment: moment
    }
  },
  watch: {
    page () {
      this.getProtocols()
    }
  },
  created () {
    this.getProtocols()
  },
  methods: {
    ...mapActions(['deleteProtocolFromIdb', 'getProtocolWhereApiID']),
    async deleteProtocol (protocol) {
      return new Promise((resolve, reject) => {
        axios({
          url: 'protocols/' + protocol.id,
          method: 'DELETE'
        }).then(response => {
          this.getProtocols()
        }).catch(error => {
          console.log(error.response.data)
        })
      })
    },
    deleteProtocolWarning (protocol) {
      this.deleted_protocol = protocol
      this.$bvModal.show('delete_modal')
      this.warning_modal = true
    },
    async getProtocols () {
      return new Promise((resolve, reject) => {
        axios({
          url: 'protocols',
          params: {filters: this.filters, page: this.page},
          method: 'GET'
        }).then(response => {
          this.protocols = response.data.protocols.data
          this.page = response.data.protocols.current_page
          let maxPage = Math.ceil(response.data.protocols.total / response.data.protocols.per_page)
          this.pages = []
          for (let i = 1; i <= maxPage; i++) this.pages.push(i)
        }).catch(error => {
          console.log(error.response.data)
        })
      })
    },
    async editProtocol (protocol) {
      let localProtocols = await this.getProtocolWhereApiID(protocol.id)
      if (localProtocols.length > 0) {
        this.local_protocol = localProtocols[0]
        this.api_protocol_id = protocol.id
        this.protocol_isset = true
        this.$bvModal.show('modal_protocol_isset')
      } else {
        let id = protocol.id
        await this.$router.push({name: 'ApiProtocolEdit', params: {id: id}})
      }
    },
    async deleteLocalProtocol () {
      await idb.deleteProtocol(this.local_protocol)
      let id = this.api_protocol_id
      await this.$router.push({name: 'ApiProtocolEdit', params: {id: id}})
    },
    editLocalProtocol () {
      let localProtocol = this.local_protocol
      this.$router.push({name: 'LocalProtocolEdit', params: {id: localProtocol.id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/api/Protocols.vue